import { lazyWithRetry as lazy } from './lazyWithRetry';
import { withProtected } from './withProtected';
import { withFeatureFlag } from './withFeatureFlag';
import { ORG_DOCUMENT_HISTORY_FLAG } from '../constants/orgDocumentHistory';
import { CUSTOM_EMAILS_FLAG } from '../constants/emailTemplates';
import { UserGroup } from '../types/user';
import { redirect } from 'react-router-dom';

export const admin = [
	{
		path: '/admin/',
		Component: withProtected(
			lazy(() => import('../pages/Admin')),
			[UserGroup.Admin]
		),
		handle: {
			key: 'pages.admin.title'
		},
		children: [
			{
				path: '/admin/',
				loader: () => redirect('/admin/dashboard/')
			},
			{
				path: '/admin/dashboard/',
				Component: lazy(() => import('../pages/Admin/Dashboard')),
				handle: {
					key: 'pages.admin.dashboard.title'
				}
			},
			{
				path: '/admin/home',
				Component: lazy(() => import('../pages/Admin/Home')),
				handle: {
					key: 'pages.admin.home.title'
				}
			},
			{
				path: '/admin/partners',
				Component: lazy(() => import('../pages/Admin/Partners/List')),
				handle: {
					key: 'pages.admin.partners.title'
				}
			},
			{
				path: '/admin/organisations/',
				Component: lazy(() => import('../pages/Admin/Organisations/')),
				handle: {
					key: 'pages.admin.organisations.title'
				},
				children: [
					{
						path: '/admin/organisations/',
						Component: lazy(() => import('../pages/Admin/Organisations/List'))
					},
					{
						path: '/admin/organisations/:organisationId',
						Component: lazy(() => import('../pages/Admin/Organisations/NewOrganisation'))
					},
					{
						path: '/admin/organisations/order-history/:organisationId',
						Component: lazy(() => import('../pages/Admin/MasterBiller/OrderHistory'))
					}
				]
			},
			{
				path: '/admin/users/',
				Component: lazy(() => import('../pages/Admin/Users/')),
				handle: {
					key: 'pages.admin.users.title'
				},
				children: [
					{
						path: '/admin/users/',
						Component: lazy(() => import('../pages/Admin/Users/List'))
					},
					{
						path: '/admin/users/export-history',
						Component: lazy(() => import('../pages/Admin/Users/ExportHistory'))
					},
					{
						path: '/admin/users/:id',
						Component: lazy(() => import('../pages/Admin/Users/User'))
					}
				]
			},
			{
				path: '/admin/advertisement',
				Component: lazy(() => import('../pages/Admin/Advertisement')),
				handle: {
					key: 'pages.admin.advertisement.title'
				}
			},
			{
				path: '/admin/masterbiller',
				Component: lazy(() => import('../pages/Admin/MasterBiller')),
				handle: {
					key: 'pages.admin.digitalProducts.masterBiller.title'
				},
				children: [
					{
						path: '/admin/masterbiller/organisations',
						Component: lazy(() => import('../pages/Admin/MasterBiller/Organisations'))
					},
					{
						path: '/admin/masterbiller/invite',
						Component: lazy(() => import('../pages/Admin/MasterBiller/InviteClient'))
					},
					{
						path: '/admin/masterbiller/invite/summary',
						Component: lazy(() => import('../pages/Admin/MasterBiller/InviteClient/ClientSummary'))
					}
				]
			},
			{
				path: '/admin/digital-products',
				Component: lazy(() => import('../pages/Admin/DigitalProducts')),
				handle: {
					key: 'pages.admin.digitalProducts.products.title'
				},
				children: [
					{
						path: '/admin/digital-products/',
						Component: lazy(() => import('../pages/Admin/DigitalProducts/List'))
					},
					{
						path: '/admin/digital-products/add',
						Component: lazy(() => import('../components/ui/organisms/Admin/AddProduct'))
					},
					{
						path: '/admin/digital-products/edit/:id',
						Component: lazy(() => import('../components/ui/organisms/Admin/EditProduct'))
					}
				]
			},
			{
				path: '/admin/badges',
				Component: lazy(() => import('../pages/Admin/Badges')),
				handle: {
					key: 'pages.badges.title'
				},
				children: [
					{
						path: '/admin/badges/',
						Component: lazy(() => import('../pages/Admin/Badges/List'))
					},
					{
						path: '/admin/badges/add',
						Component: lazy(() => import('../pages/Admin/Badges/BadgeForm'))
					},
					{
						path: '/admin/badges/edit/:id',
						Component: lazy(() => import('../pages/Admin/Badges/BadgeForm'))
					}
				]
			},
			{
				path: '/admin/mood-gifs',
				Component: lazy(() => import('../pages/Admin/MoodGifs')),
				handle: {
					key: 'pages.admin.moodGifs.title'
				},
				children: [
					{
						path: '/admin/mood-gifs/',
						Component: lazy(() => import('../pages/Admin/MoodGifs/List'))
					}
				]
			},
			{
				path: '/admin/easter-eggs',
				Component: lazy(() => import('../pages/Admin/EasterEggs')),
				handle: {
					key: 'pages.admin.easterEggs.title'
				},
				children: [
					{
						path: '/admin/easter-eggs/',
						Component: lazy(() => import('../pages/Admin/EasterEggs/List'))
					}
				]
			},
			{
				path: '/admin/quotes',
				Component: lazy(() => import('../pages/Admin/Quotes')),
				handle: {
					key: 'pages.admin.quotes.title'
				},
				children: [
					{
						path: '/admin/quotes/',
						Component: lazy(() => import('../pages/Admin/Quotes/List'))
					}
				]
			},
			{
				path: '/admin/tips',
				Component: lazy(() => import('../pages/Admin/Tips')),
				handle: {
					key: 'pages.admin.tips.title'
				},
				children: [
					{
						path: '/admin/tips/',
						Component: lazy(() => import('../pages/Admin/Tips/List'))
					}
				]
			},
			{
				path: '/admin/digital-coupons',
				Component: lazy(() => import('../pages/Admin/DigitalCoupons')),
				handle: {
					key: 'pages.admin.digitalProducts.products.title'
				},
				children: [
					{
						path: '/admin/digital-coupons/',
						Component: lazy(() => import('../pages/Admin/DigitalCoupons/List'))
					} /*,
					{
						path: '/admin/digital-products/add',
						Component: lazy(() => import('../components/ui/organisms/Admin/AddProduct'))
					}*/
				]
			},
			{
				path: '/admin/dashboards',
				Component: lazy(() => import('../pages/Admin/Dashboards')),
				handle: {
					key: 'pages.admin.dashboard.title'
				},
				children: [
					{
						path: '/admin/dashboards/',
						Component: lazy(() => import('../pages/Admin/Dashboards/List'))
					} /*,
					{
						path: '/admin/digital-products/add',
						Component: lazy(() => import('../components/ui/organisms/Admin/AddProduct'))
					}*/
				]
			},
			{
				path: '/admin/order-history',
				Component: lazy(() => import('../pages/Admin/OrderHistory')),
				handle: {
					key: 'pages.admin.orderHistory.title'
				},
				children: [
					{
						path: '/admin/order-history/',
						Component: lazy(() => import('../pages/Admin/OrderHistory/OrderHistory'))
					},
					{
						path: '/admin/order-history/:orderId',
						Component: lazy(() => import('../pages/Admin/OrderHistory/OrderDetails'))
					}
				]
			},
			{
				path: '/admin/advisor-bookings',
				Component: lazy(() => import('../pages/Admin/AdvisorBookings')),
				handle: {
					key: 'pages.admin.advisorBookings.title'
				},
				children: [
					{
						path: '/admin/advisor-bookings/',
						Component: lazy(() => import('../pages/Admin/AdvisorBookings/AdvisorBookingsList'))
					},
					{
						path: '/admin/advisor-bookings/:bookingId',
						Component: lazy(() => import('../pages/Admin/AdvisorBookings/AdminBookingDetail'))
					}
				]
			},
			{
				path: '/admin/ai-assistant',
				Component: lazy(() => import('../pages/Admin/AiAssistant')),
				handle: {
					key: 'pages.aiAssistant.title'
				},
				children: [
					{
						path: '/admin/ai-assistant/',
						Component: lazy(() => import('../pages/Admin/AiAssistant/List'))
					},
					{
						path: '/admin/ai-assistant/feedback/:id',
						Component: lazy(() => import('../pages/Admin/AiAssistant/Feedback'))
					},
					{
						path: '/admin/ai-assistant/knowledge-base',
						Component: lazy(() => import('../pages/Admin/AiAssistant/KnowledgeBase'))
					},
					{
						path: '/admin/ai-assistant/knowledge-base/edit',
						Component: lazy(() => import('../pages/Admin/AiAssistant/FileEditor'))
					},
					{
						path: '/admin/ai-assistant/instructions',
						Component: lazy(() => import('../pages/Admin/AiAssistant/Instructions'))
					},
					{
						path: '/admin/ai-assistant/configuration',
						Component: lazy(() => import('../pages/Admin/AiAssistant/Configuration'))
					},
					{
						path: '/admin/ai-assistant/guardrails',
						Component: lazy(() => import('../pages/Admin/AiAssistant/Guardrails'))
					},
					{
						path: '/admin/ai-assistant/triage-settings',
						Component: lazy(() => import('../pages/Admin/AiAssistant/TriageSettings'))
					}
				]
			},
			{
				path: '/admin/resource-hub',
				Component: lazy(() => import('../pages/Admin/ResourceHub')),
				handle: {
					key: 'pages.resourceHub.title'
				},
				children: [
					{
						path: '/admin/resource-hub/',
						Component: lazy(() => import('../pages/Admin/ResourceHub/List'))
					},
					{
						path: '/admin/resource-hub/add',
						Component: lazy(() => import('../pages/Admin/ResourceHub/AddResource'))
					},
					{
						path: '/admin/resource-hub/edit/:id',
						Component: lazy(() => import('../pages/Admin/ResourceHub/EditResource'))
					}
				]
			},
			{
				path: '/admin/appearance',
				Component: lazy(() => import('../pages/Admin/Appearance')),
				handle: {
					key: 'pages.admin.appearance.title'
				}
			},
			{
				path: '/admin/feature-flags',
				Component: lazy(() => import('../pages/Admin/FeatureFlags')),
				handle: {
					key: 'pages.admin.featureFlags.title'
				}
			},
			{
				path: '/admin/school-directory',
				Component: lazy(() => import('../pages/Admin/SchoolDirectory')),
				handle: {
					key: 'pages.admin.schoolDirectory.title'
				}
			},
			{
				path: '/admin/sharing-overview',
				Component: withFeatureFlag(
					lazy(() => import('../pages/Admin/SharingOverview')),
					'share-tracking-enabled'
				),
				handle: {
					key: 'pages.admin.sharingOverview.title'
				}
			},
			{
				// The app-admin counterpart of the organisation dashboard. Gated on the same
				// flag as the org view: if the feature is off, there is nothing to moderate.
				path: '/admin/document-history',
				Component: withFeatureFlag(
					lazy(() => import('../pages/Admin/DocumentHistoryOverview')),
					ORG_DOCUMENT_HISTORY_FLAG
				),
				handle: {
					key: 'pages.admin.documentHistory.title'
				}
			},
			{
				path: '/admin/system',
				Component: lazy(() => import('../pages/Admin/System')),
				handle: {
					key: 'pages.admin.system.title'
				}
			},
			{
				path: '/admin/legal',
				Component: lazy(() => import('../pages/Admin/Legal')),
				handle: {
					key: 'pages.admin.legal.title'
				}
			},
			{
				// Default-off: the page edits copy that only reaches sent emails once the
				// flag is on, so the URL is closed with the nav item.
				path: '/admin/email-templates',
				Component: withFeatureFlag(
					lazy(() => import('../pages/Admin/EmailTemplates')),
					CUSTOM_EMAILS_FLAG
				),
				handle: {
					key: 'pages.admin.emailTemplates.title'
				}
			},
			{
				path: '/admin/faq',
				Component: lazy(() => import('../pages/Admin/Faq')),
				handle: {
					key: 'pages.admin.faqBuilder.title'
				}
			},
			{
				path: '/admin/support',
				Component: lazy(() => import('../pages/Admin/CaseManagement')),
				handle: {
					key: 'pages.admin.support.title'
				},
				children: [
					{
						path: '/admin/support/',
						Component: lazy(() => import('../pages/Admin/CaseManagement/KbGaps'))
					},
					{
						path: '/admin/support/cases',
						Component: lazy(() => import('../pages/Admin/CaseManagement/CasesList'))
					},
					{
						path: '/admin/support/triage',
						Component: lazy(() => import('../pages/Admin/CaseManagement/TriageQueue'))
					},
					// Conversation detail is nested under the tab it was opened from, so
					// the tab bar keeps the right tab active and the screen is not
					// coupled to KB Gaps. A bare /admin/support/:conversationId would
					// match no tab and fall back to the first one (KB Gaps).
					{
						path: '/admin/support/superchat',
						Component: lazy(() => import('../pages/Admin/Superchat'))
					},
					{
						path: '/admin/support/cases/:conversationId',
						Component: withFeatureFlag(
							lazy(() => import('../pages/Admin/CaseManagement/ConversationDetail')),
							'conversation-screen-enabled'
						)
					},
					{
						path: '/admin/support/triage/:conversationId',
						Component: withFeatureFlag(
							lazy(() => import('../pages/Admin/CaseManagement/ConversationDetail')),
							'conversation-screen-enabled'
						)
					}
				]
			}

			// {
			// 	path: '/admin/verificationAuthority',
			// 	Component: lazy(() => import('../pages/Admin/VerificationAuthority')),
			// 	handle: {
			// 		key: 'pages.admin.verificationAuthority.title'
			// 	}
			// },

			// {
			// 	path: '/admin/agents',
			// 	Component: lazy(() => import('../pages/Admin/Agents')),
			// 	handle: {
			// 		key: 'pages.admin.agents.title'
			// 	}
			// },
		]
	}
];
